__turbopack_context__.v({
  "path": "style-module__dqKHeq__path",
  "rotate": "style-module__dqKHeq__rotate",
  "rotateLogo": "style-module__dqKHeq__rotateLogo",
  "rotateLogoContainer": "style-module__dqKHeq__rotateLogoContainer",
  "rotateSpinner": "style-module__dqKHeq__rotateSpinner",
  "shadowLogo": "style-module__dqKHeq__shadowLogo",
  "spinner": "style-module__dqKHeq__spinner",
  "threeDotLoadingContainer": "style-module__dqKHeq__threeDotLoadingContainer",
});
